var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-banner",
    _vm._b(
      {
        staticClass: "rb-plp-hero-banner",
        class: { "--no-bg": _vm.componentNoBg },
        attrs: {
          size: "xsmall",
          "controls-position": "bottom-right",
          "controls-mobile-position": "top-left",
          "is-copy-external": _vm.isMobile,
          "text-align": "left",
          "content-position": "left",
          "is-with-no-image-bg": !_vm.componentNoBg,
          "inherit-message-color-from-theme": true,
          "vertical-spacing": "xsmall",
          "heading-tag": "h1",
          "is-skeleton-in-loading-image": true,
          "is-v-cta-directive-enabled": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "image",
              fn: function () {
                return [_vm._t("image")]
              },
              proxy: true,
            },
            {
              key: "message",
              fn: function () {
                return [_vm._t("message")]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [
                  _c("html-fragment", {
                    attrs: { html: _vm.getSeoConf.title },
                  }),
                  _vm._v(" "),
                  _vm.isMobile && !_vm.isPlpExclusive
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "rb-plp-header__title-number-of-products",
                        },
                        [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.getSeoConf.totalNumberOfProducts) +
                              ")"
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "title_block",
              fn: function () {
                return [_vm._t("title_block")]
              },
              proxy: true,
            },
            {
              key: "excerpt",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " + _vm._s(_vm.getSeoConf.description) + "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "excerpt_block",
              fn: function () {
                return [_vm._t("excerpt_block")]
              },
              proxy: true,
            },
            {
              key: "cta_1",
              fn: function () {
                return [_vm._t("cta_1")]
              },
              proxy: true,
            },
            {
              key: "cta_2",
              fn: function () {
                return [_vm._t("cta_2")]
              },
              proxy: true,
            },
            {
              key: "cta_block",
              fn: function () {
                return [_vm._t("cta_block")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "rb-banner",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }